import axios from "axios";

export default (api: typeof axios, endpoint: string) => {
  return api.get(endpoint)
    .then(({data}) => data['hydra:totalItems']);
}
